import { qnTexts } from '../themes/_palette';

export const MuiIconButton = {
    styleOverrides: {
        root: {
            color: 'var(--mui-palette-secondary-textIconColor)',
            "&:focus-within": {
                backgroundColor: 'rgba(var(--mui-palette-action-activeChannel) / 0.07)'
            }   
        }
    }
}
